import React, { useEffect, useState } from 'react';
import { Globe, ShoppingBag } from 'lucide-react';
import appDataService, { Shop } from '../services/appDataService';
import ListingExplorer, {
  ListingFilterDef,
  ListingBadge,
  ListingItem,
} from '../components/listings/ListingExplorer';

const FILTERS: ListingFilterDef[] = [
  {
    key: 'online',
    label: 'Online-Shop',
    icon: Globe,
    test: (i) => !!(i as Shop).shopLink && (i as Shop).shopLink!.trim().length > 0,
  },
];

const badgesFor = (item: ListingItem): ListingBadge[] => {
  const shop = item as Shop;
  const badges: ListingBadge[] = [];
  if (shop.shopLink && shop.shopLink.trim().length > 0) {
    badges.push({ key: 'online', label: 'Online-Shop', icon: Globe });
  }
  return badges;
};

const ShopsPage: React.FC = () => {
  const [shops, setShops] = useState<Shop[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    appDataService
      .getShops()
      .then((data) => {
        if (!cancelled) setShops(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setShops([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ListingExplorer
      items={shops}
      loading={loading}
      title="Dart-Shops"
      subtitle="Dart-Equipment, Boards & Zubehör – online und vor Ort"
      searchPlaceholder="Shop oder Ort suchen..."
      emptyIcon={ShoppingBag}
      fallbackIcon={ShoppingBag}
      emptyLabel="Keine Shops gefunden"
      routeBase="/shop"
      filters={FILTERS}
      badges={badgesFor}
      seoTitle="Dart-Shops & Equipment | DartCloud"
      seoDescription="Finde Dart-Shops für Equipment, Boards und Zubehör – online und in deiner Nähe auf DartCloud."
    />
  );
};

export default ShopsPage;
